import styled from "styled-components";

const Page = styled.div`
  display: flex;
  flex-direction: column;
`;

export default Page;
